import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        fields: '=',
        sites: '=',
        canManageCourse: '=',
        certificates: '='
    },
    template: `
        <courses-courses-steps-general
            course="vm.course"
            fields="vm.fields"
            context="vm.context"
            sites="vm.sites"
            can-manage-course="vm.canManageCourse"
            certificates="vm.certificates"
        />`
})

export default class {
    constructor () {
        this.context = 'edit';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/general/index.js